import React, { forwardRef } from 'react'


/**
 * Componente genérico para listas desplegables (Select).
 *
 * @param {string} id - El identificador del elemento select.
 * @param {string} value - El valor seleccionado actualmente.
 * @param {function} onChange - Función que maneja los cambios del select.
 * @param {Array} options - Lista de opciones para mostrar en el select. Cada opción debe ser un objeto con { id, name }.
 * @param {string} placeholder - Texto predeterminado que se muestra como primera opción.
 * @param {boolean} disabled - Indica si el select debe estar deshabilitado.
 * @param {string} error - Mensaje de error asociado al campo.
 * @param {boolean} isSubmitted - Indica si el formulario ha sido enviado.
 * @param {object} ref - Referencia al elemento select.
 */
const Select = forwardRef(({ id, value, onChange, options, placeholder, disabled = false, error, isSubmitted }, ref) => {
  return (
    <div className='SignUpMain__Container__LoginForm-Input-Container'>
      <div className='SignUpMain__Container__LoginForm-Input-Wrapper'>
        <select
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`SignUpMain__Container__LoginForm-Input-Container-Select ${isSubmitted && ( error ? 'SignUpMain__Container__LoginForm-Input-Container-Input-Error' : 'SignUpMain__Container__LoginForm-Input-Container-Input-Success' )}`}
        >
          <option value=''>{placeholder}</option>
          {options && options.map((option) => (
            <option key={option.id} value={option.id}>{option.name}</option>
          ))}
        </select>

        {/* Ícono de validación */}
        {isSubmitted && (
          <span className="SignUpMain__Container__LoginForm-Input-Container-Input-Icon-Container">
            <i className={`bi ${error ? 'bi-x-circle-fill text-danger' : 'bi-check-circle-fill text-success'}`} />
          </span>
        )}
      </div>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className='SignUpMain__Container__LoginForm-Input-Container-Input-Error-Message'>{error}</div>}
    </div>
  )
})

export { Select };